export default __webpack_public_path__ + "static/media/Azonix.9091792c.otf";